import axios from 'axios'

export default() => {
  return axios.create({
      baseURL: `https://pmapi.fotocolombo.it`
      // baseURL: `http://localhost:3000`
  })
}



// WEBPACK FOOTER //
// ./src/services/Api.js